import { AloftPrice } from '@aloft/toolkit-shared';

import { CostApproachSummaryTextRow } from './CostApproachSummaryTextRow.js';

export const CostApproachSummaryManufacturedDepreciationRow = ({
  label,
  depreciation,
}: {
  label: string;
  depreciation: AloftPrice | undefined;
}) => (
  <CostApproachSummaryTextRow
    label={label}
    value={depreciation ? `= (${depreciation.toString(true)})` : ''}
  />
);
